// Generated by purs version 0.15.15
import * as CSS_Render from "../CSS.Render/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Hashable from "../Data.Hashable/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var hash = /* #__PURE__ */ Data_Hashable.hash(Data_Hashable.hashableString);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var Style = function (x) {
    return x;
};
var semigroupStyle = {
    append: function (v) {
        return function (v1) {
            return v + (";\x0a" + v1);
        };
    }
};
var append2 = /* #__PURE__ */ Data_Semigroup.append(semigroupStyle);
var monoidStyle = {
    mempty: "",
    Semigroup0: function () {
        return semigroupStyle;
    }
};
var isStylesUnit = {
    toCss: function (v) {
        return "";
    }
};
var isStylesStyle = {
    toCss: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var isStylesString = {
    toCss: Style
};
var isStylesCSS = {
    toCss: /* #__PURE__ */ (function () {
        var $41 = Data_Maybe.fromMaybe("");
        return function ($42) {
            return Style($41(CSS_Render.renderedInline(CSS_Render.render($42))));
        };
    })()
};
var isStylesArrayStyle = {
    toCss: /* #__PURE__ */ Data_Array.fold(monoidStyle)
};
var isStylesArrayString = {
    toCss: /* #__PURE__ */ (function () {
        var $43 = Data_String_Common.joinWith("\x0a");
        var $44 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return v + ";";
        });
        return function ($45) {
            return Style($43($44($45)));
        };
    })()
};
var unStyle = function (v) {
    return v;
};
var toCss = function (dict) {
    return dict.toCss;
};
var isStyles$div$bslash = function (dictIsStyles) {
    var toCss1 = toCss(dictIsStyles);
    return function (dictIsStyles1) {
        var toCss2 = toCss(dictIsStyles1);
        return {
            toCss: function (v) {
                return append2(toCss1(v.value0))(toCss2(v.value1));
            }
        };
    };
};
var styled = function (dictIsStyles) {
    var toCss1 = toCss(dictIsStyles);
    return function (elem) {
        return function (styles) {
            return function (attrs) {
                return elem(append1(attrs)([ (function () {
                    var v = toCss1(styles);
                    return Halogen_HTML_Properties.style(v);
                })() ]));
            };
        };
    };
};
var mkScopedStyleSheet = function (sheet) {
    var className = "hashed" + show(hash(sheet));
    var newSheet = Data_String_Common.replaceAll("$unique")("." + coerce(className))(sheet);
    return {
        className: className,
        sheet: newSheet
    };
};
export {
    Style,
    mkScopedStyleSheet,
    styled,
    toCss,
    unStyle,
    monoidStyle,
    semigroupStyle,
    isStylesCSS,
    isStylesUnit,
    isStylesStyle,
    isStylesString,
    isStylesArrayStyle,
    isStylesArrayString,
    isStyles$div$bslash
};
